import { render, staticRenderFns } from "./DarkToggler.vue?vue&type=template&id=3754d8aa"
import script from "./DarkToggler.vue?vue&type=script&lang=js"
export * from "./DarkToggler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports